import useActivationObject from '../../../providers/ActivationObjectProvider/hooks/useActivationObject'
import { Step2Props, useStep2Props } from '../types'
import { useStep2Form } from './useStep2Form'
import useStep2FormOptions from './useStep2.form.options'
import useStep2FormConditions from './useStep2.form.conditions'
import { DynamicRequestBody } from '../../../../api/dynamicSites/types'
import { useCallback, useContext, useEffect, useState } from 'react'
import {
    useDynamicDataMutation,
    useFetchMultipleImages,
} from '../../../../api/dynamicSites/hooks'
import { StepperContext } from '../../Progress/Progress'

const useStep2 = (props: useStep2Props): Step2Props => {
    const { data: activationObject, isUpdating, update } = useActivationObject()
    const formProps = useStep2Form(activationObject)
    const options = useStep2FormOptions(formProps.form, activationObject)
    const conditionsProps = useStep2FormConditions(
        formProps.form,
        options,
        activationObject,
    )
    // const [dynamicData, setDynamicData] = useState<
    //     DynamicSiteResponse | undefined | null
    // >()
    const {
        data: dynamicData,
        mutate: mutateDynamicData,
        isLoading: dynamicDataLoading,
    } = useDynamicDataMutation()

    const { setShowStepper } = useContext(StepperContext)
    const [showTakeKeyModal, setShowTakeKeyModal] = useState(false)
    const [showBackKeyModal, setShowBackKeyModal] = useState(false)

    const handleTakeKeyModalClose = () => setShowTakeKeyModal(false)
    const handleBackKeyModalClose = () => setShowBackKeyModal(false)
    const handleTakeKeyModalSwitch = () => setShowTakeKeyModal(true)
    const handleBackKeyModalSwitch = () => setShowBackKeyModal(true)
    const dynamicImages = useFetchMultipleImages(
        dynamicData?.site?.images || [],
    )

    const handlePrimaryAction = useCallback(() => {
        if (activationObject) {
            const dynamicBody = {
                synonym: activationObject.synonym,
                mainSite: dynamicData?.site?.primaryAction?.mainSite,
                type: dynamicData?.site?.primaryAction?.type,
                dynamicSiteNumber:
                    dynamicData?.site?.primaryAction?.dynamicSiteNumber,
            } as DynamicRequestBody

            mutateDynamicData(dynamicBody)
        }
    }, [
        activationObject,
        dynamicData?.site?.primaryAction?.dynamicSiteNumber,
        dynamicData?.site?.primaryAction?.mainSite,
        dynamicData?.site?.primaryAction?.type,
        mutateDynamicData,
    ])

    const handleSubAction = useCallback(() => {
        if (activationObject) {
            const dynamicBody = {
                synonym: activationObject.synonym,
                mainSite: dynamicData?.site?.subAction?.mainSite,
                type: dynamicData?.site?.subAction?.type,
                dynamicSiteNumber:
                    dynamicData?.site?.subAction?.dynamicSiteNumber,
            } as DynamicRequestBody

            mutateDynamicData(dynamicBody)
        }
    }, [
        activationObject,
        dynamicData?.site?.subAction?.dynamicSiteNumber,
        dynamicData?.site?.subAction?.mainSite,
        dynamicData?.site?.subAction?.type,
        mutateDynamicData,
    ])

    const handleInvoiceRedirect = useCallback(() => {
        if (activationObject) {
            const dynamicBody = {
                synonym: activationObject.synonym,
                mainSite: 'Invoicing',
                type: 'Redirect',
                dynamicSiteNumber: null,
            } as DynamicRequestBody

            mutateDynamicData(dynamicBody)
        }
    }, [activationObject, mutateDynamicData])

    useEffect(() => {
        if (activationObject) {
            const dynamicBody = {
                synonym: activationObject.synonym,
                type: 'Redirect',
                mainSite: activationObject.actualWizardStep.mainStep,
                dynamicSiteNumber: activationObject.actualWizardStep.subStep,
            } as DynamicRequestBody

            mutateDynamicData({ ...dynamicBody })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activationObject?.actualWizardStep, mutateDynamicData])

    useEffect(() => {
        if (dynamicData) {
            setShowStepper(dynamicData?.site?.type !== 'Selection')
        }
    }, [dynamicData, setShowStepper])

    return {
        ...props,
        activationObject,
        form: formProps,
        options: options,
        conditions: conditionsProps,
        isUpdating,
        update,
        dynamicSiteData: dynamicData?.site,
        dynamicDataLoading,
        handlePrimaryAction,
        handleSubAction,
        dynamicImages,
        keyModalActions: {
            showTakeKeyModal,
            setShowTakeKeyModal,
            handleTakeKeyModalClose,
            handleTakeKeyModalSwitch,
            showBackKeyModal,
            setShowBackKeyModal,
            handleBackKeyModalClose,
            handleBackKeyModalSwitch,
            handleInvoiceRedirect,
        },
    }
}

export default useStep2
